var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventAvailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11104_7752",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11104_7752)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.125 13.1796L12.1892 10.1154C12.3131 9.99154 12.4624 9.92821 12.6371 9.92543C12.8117 9.92279 12.9636 9.98612 13.0929 10.1154C13.2222 10.2447 13.2869 10.3954 13.2869 10.5673C13.2869 10.7392 13.2222 10.8899 13.0929 11.0192L9.65229 14.46C9.5016 14.6106 9.32583 14.6858 9.125 14.6858C8.92416 14.6858 8.7484 14.6106 8.59771 14.46L6.90708 12.7692C6.78319 12.6453 6.71986 12.496 6.71708 12.3213C6.71444 12.1467 6.77778 11.9947 6.90708 11.8654C7.03639 11.7361 7.18701 11.6715 7.35896 11.6715C7.5309 11.6715 7.68153 11.7361 7.81083 11.8654L9.125 13.1796ZM4.42312 17.9167C4.00215 17.9167 3.64583 17.7708 3.35416 17.4792C3.0625 17.1875 2.91666 16.8312 2.91666 16.4102V5.25647C2.91666 4.8355 3.0625 4.47918 3.35416 4.18751C3.64583 3.89585 4.00215 3.75001 4.42312 3.75001H5.57687V2.62814C5.57687 2.4455 5.63805 2.293 5.76041 2.17064C5.88278 2.04842 6.03528 1.9873 6.21791 1.9873C6.40069 1.9873 6.55319 2.04842 6.67541 2.17064C6.79778 2.293 6.85896 2.4455 6.85896 2.62814V3.75001H13.1731V2.6123C13.1731 2.43494 13.2329 2.2864 13.3525 2.16668C13.4722 2.0471 13.6208 1.9873 13.7981 1.9873C13.9755 1.9873 14.124 2.0471 14.2435 2.16668C14.3633 2.2864 14.4231 2.43494 14.4231 2.6123V3.75001H15.5769C15.9978 3.75001 16.3542 3.89585 16.6458 4.18751C16.9375 4.47918 17.0833 4.8355 17.0833 5.25647V16.4102C17.0833 16.8312 16.9375 17.1875 16.6458 17.4792C16.3542 17.7708 15.9978 17.9167 15.5769 17.9167H4.42312ZM4.42312 16.6667H15.5769C15.641 16.6667 15.6998 16.6399 15.7531 16.5865C15.8066 16.5331 15.8333 16.4744 15.8333 16.4102V8.5898H4.16666V16.4102C4.16666 16.4744 4.1934 16.5331 4.24687 16.5865C4.30021 16.6399 4.35896 16.6667 4.42312 16.6667ZM4.16666 7.3398H15.8333V5.25647C15.8333 5.1923 15.8066 5.13355 15.7531 5.08022C15.6998 5.02675 15.641 5.00001 15.5769 5.00001H4.42312C4.35896 5.00001 4.30021 5.02675 4.24687 5.08022C4.1934 5.13355 4.16666 5.1923 4.16666 5.25647V7.3398Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventAvailable);
export default __webpack_public_path__ + "static/media/event_available.79a1329850cd05e2b67e1d2276b5edd8.svg";
export { ForwardRef as ReactComponent };